<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row mt-3">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <b-row>
                  <b-col lg="2" class="mt-4">
                    <b-button class="btn-primary" @click="toggleFilters">{{ showFilters ? 'Hide Filters' : 'Filter' }}</b-button>
                  </b-col>
                  <b-col lg="1" class="mt-4">
                    <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                      <b-button-group class="mx-1">
                        <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" :title="translate('exportToExcel')"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                        <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" :title="translate('exportToPdf')"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </b-col>
                </b-row>
                <b-collapse v-model="showFilters">
                  <b-row class="mt-3">
                    <b-col lg="2">
                      <label class="some-label" for="select-building">{{ translate('associationType') }}</label>
                      <b-form-select id="select-building" v-model="selectedAssociationType" :options="assocationTypeOptions"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <label for="datepicker-from">{{ translate('dateFrom') }}</label>
                      <b-form-input v-model="DateFrom" id="datepicker-from" type="date" size="sm"></b-form-input>
                    </b-col>
                    <b-col lg="2">
                      <label for="datepicker-to">{{ translate('dateTo') }}</label>
                      <b-form-input v-model="DateTo" id="datepicker-to" type="date" size="sm"></b-form-input>
                    </b-col>
                    <b-col lg="2">
                      <label for="payment-method">Payment Method</label>
                      <b-form-select id="payment-method" v-model="selectedPaymentMethod" :options="paymentMethodOptions"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <label for="transaction-ref">Transaction Ref</label>
                      <b-form-input id="transaction-ref" v-model="transactionRef" placeholder="Transaction Reference"></b-form-input>
                    </b-col>
                    <b-col lg="2">
                      <label class="some-label" for="member-phone">{{ translate('phoneNumber') }}</label>
                      <div class="input-group">
                        <span class="input-group-text">+251</span>
                        <b-form-input 
                          id="member-phone" 
                          v-model="phoneNumber"  
                          :placeholder="translate('phoneNumber')" 
                          type="tel"
                          maxlength="9">
                        </b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="2">
                      <b-button class="btn-secondary" @click="applyFilters">{{ translate('find') }}</b-button>
                    </b-col>
                    <b-col lg="2">
                      <b-button class="btn-outline-secondary" @click="clearFilters">Clear</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 400px;"
                striped
                responsive
                hover
              >
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('member') }}</b-th>
                    <b-th>{{ translate('memberPhoneNo') }}</b-th>
                    <b-th>{{ translate('associationName') }}</b-th>
                    <b-th>{{ translate('associationType') }}</b-th>
                    <b-th>{{ translate('contributionAmount') }}</b-th>
                    <b-th>{{ translate('servicePrice') }}</b-th>
                    <b-th>{{ translate('paidFor') }}</b-th>
                    <b-th>{{ translate('paymentMethod') }}</b-th>
                    <b-th>{{ translate('dateOfPayment') }}</b-th>
                    <b-th>{{ translate('creditAccount') }}</b-th>
                    <b-th>{{ translate('transactionReference') }}</b-th>
                  </b-tr>
                </b-thead class="text-center">
                <template v-if="spinner">
                    <b-tbody class="text-center">
                      <b-tr >
                          <b-td colspan="12" class="text-center" style="display: table-cell">
                            <b-spinner
                            style="height: 3rem; width: 3rem;"
                              variant="warning"
                            ></b-spinner>
                          </b-td>
                        </b-tr>
                    </b-tbody>
                  </template>
                <template v-else>
                  <b-tbody>
                    <template v-if="filterTable.length === 0">
                        <b-tr>
                          <b-td colspan="12" class="text-center">{{ translate('nothingFound') }}</b-td>
                          <b-td></b-td>
                        </b-tr>
                    </template>
                    <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.ID"
                    >
                        <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                        <b-td>{{item.ekubMember.fullName}}</b-td>
                        <b-td>{{item.ekubMember.phoneNumber}}</b-td>
                        <b-td>{{item.ekub.ekubName}}</b-td>
                        <b-td>{{formatAssociationType(item.ekub.ekubType)}}</b-td>
                        <b-td>{{numberWithCommas(item.payedAmount)}}</b-td>
                        <b-td>{{numberWithCommas(item.serviceFee)}}</b-td>
                        <b-td>{{item.paymentForMonth}}</b-td>
                        <b-td>{{item.paymentMethod}}</b-td>
                        <b-td>{{item.paymentDate}}</b-td>
                        <b-td>{{item.creditAccount}}</b-td>
                        <b-td>{{item.transactionRef}}</b-td>
                    </b-tr>
                    </template>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
                <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import jsPDF from "jspdf";
    import autoTable from "jspdf-autotable";
    import 'jspdf-autotable';

    import { setLanguage, translate } from 'src/i18n.js';
    import NotoSansEthiopic from '../../assets/fonts/NotoSansEthiopic-Regular.ttf';
    
    export default {
      components: {   
        LTable,
        Card,
      },
      data () {
        return {
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          totalRows: 0,
          currentPage: 1,
          perPage: 7,
          selectedAssociationType: "All",
          assocationTypeOptions: [
            {text: translate('all'), value: "All"},
          ],
          selectedPaymentMethod: "By Tsehay",
          paymentMethodOptions: [
            {text: "All", value: ""},
            {text: "Uploaded Data", value: "Manually"},
            {text: "Collected By Tsehay", value: "By Tsehay"}
          ],
          transactionRef: "",
          phoneNumber: "",
          showFilters: false,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          items: [],
          filter: "",
          DateFrom: "",
          DateTo: "",
          spinner: true,
          dataExcel: []
        }
      },
      computed: {
        filterTable() {
          return this.items;
        },
      },
       mounted() {
        this.getModules();
        this.getPaymentsByOwnerID();
        this.getEkubType();
        this.$on("AfterComplete", () => {
          this.getPaymentsByOwnerID();
        });
      },
      methods: {
  //------------------------------
  translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
  getEkubType(){
           this.$store.dispatch('getAllAssociationDashboard',{userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
          .then(response=>{
              Array.from(response.data).forEach((value) => {
              this.assocationTypeOptions.push({
                value: value.id,
                text: value.ekubName
              });
            });
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
          })
        },
        async getDataForExcel() {
          this.dataExcel = [];
          
          try {
            const params = {
              superUserId: parseInt(sessionStorage.getItem("superID")),
              page: 1,
              line: this.totalRows
            };
            
            // Add optional filters
            if (this.selectedAssociationType !== "All") {
              params.ekubId = this.selectedAssociationType;
            }
            if (this.selectedPaymentMethod) {
              params.paymentMethod = this.selectedPaymentMethod;
            }
            if (this.transactionRef) {
              params.transactionRef = this.transactionRef;
            }
            if (this.phoneNumber) {
              params.memberPhoneNumber = "+251" + this.phoneNumber;
            }
            if (this.DateFrom) {
              params.startDate = this.DateFrom;
            }
            if (this.DateTo) {
              params.endDate = this.DateTo;
            }
            
            const response = await this.$store.dispatch('getPaymentsUnified', params);
            
            if (response.data.Contents.length > 0) {
              let index = 0;
              response.data.Contents.forEach(x => {
                index++;
                this.dataExcel.push({
                  No: index,
                  Member_Name: x.ekubMember.fullName,
                  Member_Phone_Number: x.ekubMember.phoneNumber,
                  Association_Name: x.ekub.ekubName,
                  Association_Type: this.formatAssociationType(x.ekub.ekubType),
                  Contribution_Amount: x.payedAmount,
                  Service_Fee: x.serviceFee,
                  Payment_Month: x.paymentForMonth,
                  Payment_Method: x.paymentMethod,
                  Date_of_Payment: x.paymentDate,
                  Credit_Account: x.creditAccount,
                  Transaction_Reference: x.transactionRef
                });
              });
            }
            
            if (this.dataExcel.length > 0) {
              const filename = 'Payments_Report.csv';
              const csvData = this.convertToCSV(this.dataExcel);
              const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
              
              if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
              } else {
                const link = document.createElement('a');
                if (link.download !== undefined) {
                  const url = URL.createObjectURL(blob);
                  link.setAttribute('href', url);
                  link.setAttribute('download', filename);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              }
            } else {
              this.$notifications.notify({
                message: "Nothing to export",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              });
            }
          } catch (error) {
            console.log(error);
            this.$notifications.notify({
              message: "Error exporting data",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          }
        },
        convertToCSV(jsonData) {
          const header = Object.keys(jsonData[0]).join(',');
          const rows = jsonData.map(row => Object.values(row).join(','));
          return `\ufeff${header}\n${rows.join('\n')}`;
        },
  
  async getDataForPDF() {
    this.dataExcel = [];
    this.spinner = true;
    
    const params = {
      superUserId: parseInt(sessionStorage.getItem("superID")),
      page: 1,
      line: this.totalRows
    };
    
    if (this.selectedAssociationType !== "All") {
      params.ekubId = this.selectedAssociationType;
    }
    if (this.selectedPaymentMethod) {
      params.paymentMethod = this.selectedPaymentMethod;
    }
    if (this.transactionRef) {
      params.transactionRef = this.transactionRef;
    }
    if (this.phoneNumber) {
      params.memberPhoneNumber = "+251" + this.phoneNumber;
    }
    if (this.DateFrom) {
      params.startDate = this.DateFrom;
    }
    if (this.DateTo) {
      params.endDate = this.DateTo;
    }
    
    try {
      const response = await this.$store.dispatch('getPaymentsUnified', params);
      
      if (response.data.Contents.length > 0) {
        let index = 0;
        response.data.Contents.forEach(x => {
          index++;
          this.dataExcel.push({
            No: index,
            Member_Name: x.ekubMember.fullName,
            Member_Phone_Number: x.ekubMember.phoneNumber,
            Association_Name: x.ekub.ekubName,
            Association_Type: this.formatAssociationType(x.ekub.ekubType),
            Contribution_Amount: x.payedAmount,
            Service_Fee: x.serviceFee,
            Payment_Month: x.paymentForMonth,
            Payment_Method: x.paymentMethod,
            Date_of_Payment: x.paymentDate,
            Credit_Account: x.creditAccount,
            Transaction_Reference: x.transactionRef
          });
        });
        
        if (this.dataExcel.length > 0) {
          const pdf = new jsPDF({ orientation: 'landscape' });
          pdf.setFont('helvetica');
          pdf.setFontSize(10);
          
          let headers = [
            "No", "Member Name", "Member Phone Number", "Association Name",
            "Association Type", "Contribution Amount", "Service Fee", "Paid Month",
            "Payment Method", "Date of Payment", "Credit Account", "Transaction Reference"
          ];
          
          let rows = this.dataExcel.map(obj => Object.values(obj));
          
          autoTable(pdf, {
            head: [headers],
            body: rows,
            styles: { fontSize: 8 },
            headStyles: {
              fillColor: [37, 91, 48],
              textColor: [240, 206, 13],
              fontSize: 8
            }
          });
          
          pdf.save("Unified_Payments_Report.pdf");
        } else {
          this.$notifications.notify({
            message: "No data to export",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      } else {
        this.$notifications.notify({
          message: "No data to export",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      }
    } catch (error) {
      console.error(error);
      this.$notifications.notify({
        message: "An error occurred while generating the PDF: " + error.message,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: 'danger'
      });
    } finally {
      this.spinner = false;
    }
  },
  //---------------------------------
        formatAssociationType(type) {
          return type === "Group" ? "Association" : type;
        },
        numberWithCommas(x) {
          if(x !== null && x !== undefined){
              x = x.toFixed(2);
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        },
        getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                var modulesList = response.data.modules;
                var PaymentModule = modulesList.filter(x=>x.name === "Payment_Super");
                if(PaymentModule !== null){
                  this.modulePermission.view = PaymentModule[0].listData;
                  this.modulePermission.create = PaymentModule[0].createData;
                  this.modulePermission.update = PaymentModule[0].updateData;
                  this.modulePermission.delete = PaymentModule[0].deleteData;
                }
            })
            .catch(error=>{
                console.log(error);
            })
        },
        getPaymentsByOwnerID(){
          this.spinner = true;
          
          const params = {
            superUserId: parseInt(sessionStorage.getItem("superID")),
            page: this.currentPage,
            line: this.perPage
          };
          
          // Add optional filters
          if (this.selectedAssociationType !== "All") {
            params.ekubId = this.selectedAssociationType;
          }
          if (this.selectedPaymentMethod) {
            params.paymentMethod = this.selectedPaymentMethod;
          }
          if (this.transactionRef) {
            params.transactionRef = this.transactionRef;
          }
          if (this.phoneNumber) {
            params.memberPhoneNumber = "+251" + this.phoneNumber;
          }
          if (this.DateFrom) {
            params.startDate = this.DateFrom;
          }
          if (this.DateTo) {
            params.endDate = this.DateTo;
          }
          
          this.$store.dispatch('getPaymentsUnified', params)
            .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
              console.log(error);
            })
            .finally(()=>{
              this.spinner = false;
            })
        },
        changePage(event, page){
          this.currentPage = page;
          this.getPaymentsByOwnerID();
        },
        changePerPage(event){
          this.currentPage = 1;
          this.getPaymentsByOwnerID();
        },
        toggleFilters(){
          this.showFilters = !this.showFilters;
        },
        applyFilters(){
          this.currentPage = 1; // Reset to first page when applying filters
          this.getPaymentsByOwnerID();
        },
        clearFilters(){
          this.selectedAssociationType = "All";
          this.selectedPaymentMethod = "By Tsehay";
          this.transactionRef = "";
          this.phoneNumber = "";
          this.DateFrom = "";
          this.DateTo = "";
          this.currentPage = 1; // Reset to first page when clearing filters
          this.getPaymentsByOwnerID();
        },

        clearData(){
          this.$emit('AfterComplete');
        },

      }
    }
  </script>
  <style>

  @font-face {
  font-family: 'NotoSansEthiopic';
  src: url('../../assets/fonts/NotoSansEthiopic-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
body {
  font-family: 'NotoSansEthiopic', sans-serif;
}
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
  }
  .mt-3 {
  margin-top: 1rem !important;
}
.align-items-center {
  align-items: center !important;
}
label.mb-0 {
  margin-bottom: 0 !important;
}
.table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 60px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
.table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}

  </style>
  